export default function Hero() {
  const handleCTAClick = () => {
    window.open('https://www.rakuten-card.co.jp/', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="relative bg-gradient-to-br from-red-50 via-white to-pink-50 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6abbd7233c53ec5f89a0285d89ab5f93.jpg"
          alt="大手ECモール系カード背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* 2026年最新版バッジ */}
      <div className="absolute top-4 right-4 sm:top-8 sm:right-8 z-10 animate-bounce">
        <div className="bg-gradient-to-r from-yellow-400 via-amber-400 to-yellow-500 text-black px-4 py-2 rounded-full font-bold text-sm shadow-lg">
          2026年最新版
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20 md:py-24 text-center">
        {/* 大きな特典数字 */}
        <div className="mb-6">
          <div className="text-white/90 text-lg sm:text-xl md:text-2xl font-medium mb-2">
            最大
          </div>
          <div className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-black mb-2">
            <span className="bg-gradient-to-r from-yellow-300 via-amber-300 to-yellow-400 bg-clip-text text-transparent">
              5,000
            </span>
          </div>
          <div className="text-white text-xl sm:text-2xl md:text-3xl font-bold">
            ポイントプレゼント
          </div>
        </div>

        {/* カード名 */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 sm:mb-6">
          大手ECモール系カード
        </h1>

        {/* サブテキスト */}
        <p className="text-base sm:text-lg md:text-xl text-white/90 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed">
          年会費永年無料・ECモールで最大3倍・顧客満足度No.1
        </p>

        {/* 信頼性バッジ */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-8 sm:mb-10">
          <div className="bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg">
            <div className="flex items-center gap-2">
              <i className="ri-vip-crown-line text-amber-500 text-lg sm:text-xl"></i>
              <span className="font-bold text-gray-800 text-sm sm:text-base">年会費永年無料</span>
            </div>
          </div>
          <div className="bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg">
            <div className="flex items-center gap-2">
              <i className="ri-percent-line text-red-500 text-lg sm:text-xl"></i>
              <span className="font-bold text-gray-800 text-sm sm:text-base">ECモールで最大3倍</span>
            </div>
          </div>
          <div className="bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg">
            <div className="flex items-center gap-2">
              <i className="ri-star-line text-orange-500 text-lg sm:text-xl"></i>
              <span className="font-bold text-gray-800 text-sm sm:text-base">顧客満足度No.1</span>
            </div>
          </div>
        </div>

        {/* CTAボタン */}
        <button
          onClick={handleCTAClick}
          className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-red-500 via-rose-500 to-red-600 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-full text-base sm:text-lg md:text-xl font-bold shadow-2xl hover:shadow-red-500/50 transition-all duration-300 hover:scale-105 whitespace-nowrap"
        >
          <span>今すぐ申し込む</span>
          <i className="ri-arrow-right-line text-xl sm:text-2xl group-hover:translate-x-1 transition-transform"></i>
        </button>
      </div>
    </section>
  );
}